// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_DOCS = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_DOCS = {
  root: path(ROOTS_DOCS, '/documentation/administration')
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  page404: '/404',
  page500: '/500',
  mobileAppRedirect: '/mobile-apps'
};

export const PATH_HOME = {
  cloud: 'https://www.sketch.com/s/0fa4699d-a3ff-4cd5-a3a7-d851eb7e17f0',
  purchase: '/pricing',
  components: '/components',
  dashboard: ROOTS_DASHBOARD
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    // ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics')
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user/account'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/card'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    create: path(ROOTS_DASHBOARD, '/user/create'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: path(ROOTS_DASHBOARD, '/user/edit')
  },
  inventory: {
    root: path(ROOTS_DASHBOARD, '/inventory/list'),
    findVehicle: path(ROOTS_DASHBOARD, '/inventory/list'),
    findVehicleCard: path(ROOTS_DASHBOARD, '/inventory/card'),
    viewVehicle: path(ROOTS_DASHBOARD, '/inventory/view'),
    viewPdf: path(ROOTS_DASHBOARD, '/inventory/pdf'),
    addVehicle: path(ROOTS_DASHBOARD, '/inventory/add'),
    editVehicle: path(ROOTS_DASHBOARD, '/inventory/edit'),
    bulkUploadVehicle: path(ROOTS_DASHBOARD, '/inventory/bulkUpload')
  },
  company: {
    root: path(ROOTS_DASHBOARD, '/company'),
    list: path(ROOTS_DASHBOARD, '/company/list'),
    create: path(ROOTS_DASHBOARD, '/company/create'),
    edit: path(ROOTS_DASHBOARD, '/company/edit')
  },
  brand: {
    root: path(ROOTS_DASHBOARD, '/brand'),
    list: path(ROOTS_DASHBOARD, '/brand/list'),
    create: path(ROOTS_DASHBOARD, '/brand/create'),
    edit: path(ROOTS_DASHBOARD, '/brand/edit')
  },
  branch: {
    root: path(ROOTS_DASHBOARD, '/branch'),
    list: path(ROOTS_DASHBOARD, '/branch/list'),
    create: path(ROOTS_DASHBOARD, '/branch/create'),
    edit: path(ROOTS_DASHBOARD, '/branch/edit')
  },
  lead: {
    root: path(ROOTS_DASHBOARD, '/lead'),
    list: path(ROOTS_DASHBOARD, '/lead/list')
  },
  system: {
    root: path(ROOTS_DASHBOARD, '/system'),
    logs: path(ROOTS_DASHBOARD, '/system/cloudwatchlogs')
  },
  pricingRequest: {
    root: path(ROOTS_DASHBOARD, '/pricing-request'),
    list: path(ROOTS_DASHBOARD, '/pricing-request/list'),
    edit: path(ROOTS_DASHBOARD, '/pricing-request/edit')
  }
};
